import React from "react";
import { Link } from "react-router-dom";
import LandingLayout from "../components/LandingLayout";
import { useRedirectIfLoggedIn } from "../hooks/useRedirectIfLoggedIn";
import LandingHero from "../components/landing/LandingHero";
import ProblemsSection from "../components/landing/ProblemsSection";
import SolutionGrid from "../components/landing/SolutionGrid";
import HowItWorks from "../components/landing/HowItWorks";
import EarlyAccessCTA from "../components/landing/EarlyAccessCTA";
import FinalCTASection from "../components/landing/FinalCTASection";

const problems = [
    {
        title: "El cliente no sabe cuánto va a costar decorar",
        description: "Antes de comprometerse con un proyecto, el cliente quiere saber cifras. Sin datos rápidos, la conversación se paraliza antes de empezar.",
    },
    {
        title: "Preparar una propuesta lleva días",
        description: "Visitar la propiedad, medir, buscar referencias, calcular materiales y presentar una propuesta consume tiempo que no siempre se cobra.",
    },
    {
        title: "Competir solo en precio",
        description: "Sin diferenciarte con datos y propuestas profesionales, acabas compitiendo contra decoradores que cobran menos.",
    },
];

const solutions = [
    {
        icon: "🎨",
        title: "Análisis de la propiedad con IA",
        description: "Sube fotos de la propiedad y obtén en segundos un desglose del estado actual: suelos, paredes, iluminación, mobiliario.",
    },
    {
        icon: "💰",
        title: "Estimación de coste de decoración",
        description: "Coste de mobiliario, materiales y mano de obra según los precios de mercado de tu zona. Sin visita previa.",
    },
    {
        icon: "📄",
        title: "Propuesta profesional en PDF",
        description: "Genera un documento con el análisis, la estimación de coste y los escenarios de decoración. Listo para el cliente.",
    },
    {
        icon: "📈",
        title: "Valor post-decoración",
        description: "Muestra al cliente cuánto se revaloriza la propiedad con cada escenario de decoración. El argumento definitivo para cerrar.",
    },
];

const steps = [
    {
        title: "Analiza la propiedad",
        description: "Sube fotos o pega la URL del anuncio. La IA detecta el estado actual de cada estancia.",
    },
    {
        title: "Configura el proyecto",
        description: "Ajusta el alcance: qué estancias intervenir, nivel de calidad y presupuesto orientativo del cliente.",
    },
    {
        title: "Presenta tu propuesta",
        description: "Descarga el PDF y preséntalo en la primera reunión. Datos concretos, aspecto profesional.",
    },
];

const LandingDecorador = () => {
    useRedirectIfLoggedIn("/analizarpropiedad/nueva");
    return (
        <LandingLayout>
            <div className="max-w-5xl mx-auto px-6 pt-4">
                <Link to="/" className="text-sm text-gray-500 hover:text-brand-blue transition-colors">
                    ← Todos los perfiles
                </Link>
            </div>

            <LandingHero
                badge="Para decoradores e interioristas"
                title="Presupuesta la decoración"
                highlight="antes de la primera visita"
                subtitle="Analiza propiedades con IA, estima el coste de decoración y genera propuestas profesionales. Gana proyectos antes que ninguno de tus competidores."
                ctaText="Analizar una propiedad"
               
                bgClass="bg-gradient-to-br from-orange-50 to-amber-100"
                highlightClass="text-orange-600"
            />

            <ProblemsSection
                title="Proyectos que no arrancan por falta de datos"
                subtitle="El cliente quiere saber el coste antes de comprometerse. Sin una estimación rápida, pierdes la oportunidad."
                problems={problems}
            />

            <SolutionGrid
                title="Tu estudio de interiorismo potenciado con IA"
                subtitle="De la foto al presupuesto en minutos, no en días."
                solutions={solutions}
            />

            <HowItWorks steps={steps} />

            <EarlyAccessCTA />

            <FinalCTASection
                title="Gana proyectos con propuestas que nadie más trae a la reunión"
                text="Analiza tu primera propiedad gratis y genera una propuesta profesional en minutos."
                ctaText="Analizar una propiedad"
                rolNombre="interiorista"
            />
        </LandingLayout>
    );
};

export default LandingDecorador;
